import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  LoggedUserError,
  LoggedUserLoaded,
  LoggedUserRequested,
  UsersError,
  UsersLoaded,
  UsersRequested,
  UsersForClientFilterError,
  UsersForClientFilterLoaded,
  UsersForClientFilterRequested
} from './users.actions';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from "../../@core/data/user/user.service";
import { ToastrConfigs } from "../../@core/data/toastr-config";
import { NbToastrService } from "@nebular/theme";

@Injectable()
export class UsersEffects {
  constructor(
    private actions$: Actions,
    private toastrService : NbToastrService,
    private userService: UserService
  ) {}

  requestUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsersRequested),
      mergeMap(() =>
        this.userService.getUsers().pipe(
          map((response: any) => UsersLoaded({ users: response?.data })),
          catchError((error: any) => of(UsersError()))
        )
      )
    )
  );

  requestUsersForClientFilter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsersForClientFilterRequested),
      mergeMap(() =>
        this.userService.getUsersForClientFilter().pipe(
          map((response: any) => UsersForClientFilterLoaded({ usersForClientFilter: response?.data })),
          catchError((error: any) => of(UsersForClientFilterError()))
        )
      )
    )
  );

  requestLoggedUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoggedUserRequested),
      mergeMap(({ userId }) =>
        this.userService.getUser(userId).pipe(
          map((response: any) => LoggedUserLoaded({ loggedUser: response?.data })),
          catchError((error: any) => of(LoggedUserError()))
        ))
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UsersError),
        tap(() => {
          this.toastrService.show(`Pentru moment lista utilizatorilor nu e disponibila!`, `Eroare`, ToastrConfigs.danger);
        })
      ),
    { dispatch: false }
  );
}
